// extracted by mini-css-extract-plugin
export default {"saveSearchButton":"saveSearchButton__MDg5N"};